import { useNavigate } from "react-router-dom"

import Style from "./style"
import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

import MainHeader from "widget/MainHeader"
import Pagenation from "widget/Pagenation"

import useGetAdvertiseList from "entity/advertiseTimer/useGetAdvertiseList"
import useDeleteAdvertise from "entity/advertiseTimer/useDeleteAdvertise"
import usePutAdvertiseActive from "entity/advertiseTimer/usePostAdvertiseActive"
import useDeleteAdvertiseActive from "entity/advertiseTimer/useDeleteAdvertiseActive"

import TStyle from "shared/style/tableStyle"
import DefaultButton from "shared/ui/DefaultButton"
import timestampCalculator from "shared/lib/timestampCalculator"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"
import TableLoading from "shared/ui/TableLoading"

const AdTimerList = () => {
    const navigate = useNavigate()

    const [advertiseList, isLoading] = useGetAdvertiseList()
    const [deleteAdvertise] = useDeleteAdvertise()
    const [activeAdvertise] = usePutAdvertiseActive()
    const [deactiveAdvertise] = useDeleteAdvertiseActive()

    const [, setConfirm] = useConfirmModalAtom()

    const btnList = [
        {
            "label": "생성",
            "clickEvent": () => navigate("/ad-timer/create"),
            "deactive": false
        }
    ]
    const sizeList = ["short", "expand", "short", "long", "medium"]
    const tableHeadList = ["IDX", "첨부파일", "활성", "생성 날짜", ""]

    const changeActiveStateEvent = (e, state, idx) => {
        e.stopPropagation()
        state
            ? deactiveAdvertise(idx)
            : activeAdvertise(idx)
    }

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList}>듀레이션 타이머 광고 목록</MainHeader>

            <TableLoading isLoading={isLoading}>
                <TStyle.TableDiv>
                    <TStyle.TableInner>
                        <TStyle.TableRow $title>
                            {tableHeadList.map((elem, index) =>
                                <TStyle.Data key={index} $title $size={sizeList[index]}>{elem}</TStyle.Data>
                            )}
                        </TStyle.TableRow>
                        {advertiseList?.data?.advertise_timer_list?.map((elem, index) =>
                            <TStyle.TableRow key={index} $odd={index % 2 === 1} $exapnd >
                                <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                                <TStyle.Data $size={sizeList[1]}>
                                    {elem?.type === "image"
                                        ? <Style.PreviewImg src={elem?.src} />
                                        : elem?.type === "video"
                                            ? <Style.PreviewVideo src={elem?.src} controls />
                                            : null
                                    }

                                </TStyle.Data>
                                <TStyle.Data $size={sizeList[2]}>
                                    <Style.Radio onClick={(e) => changeActiveStateEvent(e, elem?.is_active, elem?.idx)}><img src={elem?.is_active ? checked : check} /></Style.Radio>
                                </TStyle.Data>
                                <TStyle.Data $size={sizeList[3]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                                <TStyle.Data $size={sizeList[4]}>
                                    <DefaultButton small fitWidth clickEvent={() => navigate(`/ad-timer/${elem?.idx}/edit`)}>수정</DefaultButton>
                                    <DefaultButton small fitWidth clickEvent={() => setConfirm("정말 삭제하시겠습니까?", () => () => deleteAdvertise(elem?.idx))}>삭제</DefaultButton>
                                </TStyle.Data>
                            </TStyle.TableRow>
                        )}
                    </TStyle.TableInner>
                </TStyle.TableDiv>
            </TableLoading>

            <Pagenation maxPage={advertiseList?.data?.max_page} />
        </Style.Wrapper>
    )
}

export default AdTimerList